import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button } from 'common-src/components/base';
import { Colors, ColorsNew } from 'common-src/styles';

import BasePopup from '../BasePopup';
import styles from './DistributeResultsModal.module.scss';

const DistributeResultsModal = ({ onClose, onSubmit }) => {
  const [selectedResults, setSelectedResults] = useState({
    moca: false,
    mocaVisual: false,
    mis: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCheckboxChange = (resultType) => {
    setSelectedResults((prev) => ({
      ...prev,
      [resultType]: !prev[resultType],
    }));
  };

  const handleSubmit = async () => {
    const resultMapping = {
      moca: 'MOCA',
      mocaVisual: 'MOCA_VISUAL',
      mis: 'MIS',
    };

    const results = Object.entries(selectedResults)
      .filter(([, isSelected]) => isSelected)
      .map(([key]) => resultMapping[key]);

    if (results.length === 0) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(results);
      onClose();
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const isSubmitDisabled =
    !selectedResults.moca && !selectedResults.mocaVisual && !selectedResults.mis;

  return (
    <BasePopup id="distribute-results-modal" onClose={onClose} open title="Select results to send">
      <div className={styles.content}>
        <div className={styles.checkboxContainer}>
          <label className={styles.checkboxLabel} htmlFor="checkbox-moca">
            <input
              id="checkbox-moca"
              type="checkbox"
              checked={selectedResults.moca}
              onChange={() => handleCheckboxChange('moca')}
              className={styles.checkbox}
            />
            <span>MOCA</span>
          </label>
          <label className={styles.checkboxLabel} htmlFor="checkbox-moca-visual">
            <input
              id="checkbox-moca-visual"
              type="checkbox"
              checked={selectedResults.mocaVisual}
              onChange={() => handleCheckboxChange('mocaVisual')}
              className={styles.checkbox}
            />
            <span>MOCA Visual</span>
          </label>
          <label className={styles.checkboxLabel} htmlFor="checkbox-mis">
            <input
              id="checkbox-mis"
              type="checkbox"
              checked={selectedResults.mis}
              onChange={() => handleCheckboxChange('mis')}
              className={styles.checkbox}
            />
            <span>MIS</span>
          </label>
        </div>
      </div>
      <div className={styles.buttonsContainer}>
        <Button
          id="distribute-send-button"
          text="Send"
          backgroundColor={ColorsNew.darkGreen}
          textColor={ColorsNew.white}
          onClick={handleSubmit}
          disabled={isSubmitDisabled || isSubmitting}
          isLoading={isSubmitting}
        />
        <Button
          id="distribute-cancel-button"
          text="Cancel"
          backgroundColor={Colors.white}
          textColor={ColorsNew.darkGreen}
          borderColor={ColorsNew.darkGreen}
          onClick={onClose}
          disabled={isSubmitting}
        />
      </div>
    </BasePopup>
  );
};

DistributeResultsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default DistributeResultsModal;
